import { render, staticRenderFns } from "./PerformerList.vue?vue&type=template&id=0d8a4e36&scoped=true"
import script from "./PerformerList.vue?vue&type=script&lang=js"
export * from "./PerformerList.vue?vue&type=script&lang=js"
import style0 from "./PerformerList.vue?vue&type=style&index=0&id=0d8a4e36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8a4e36",
  null
  
)

export default component.exports